import React, { useState, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import useCustomNavigate from "../../common_nextgen/common_components/Navigation/NextGenNavigation";
import Form from "../../common_nextgen/common_components/form/Form";
import { PRICE_SCHEDULE_MODES, NO_CHANGE_OF_INFO } from "../../common_nextgen/utils/Constants";
import { useAxios } from "../../common_nextgen/axios/AxiosHelper";
import { useToast } from "../../common_nextgen/hooks/ToastContext";
import FunctionKeys from "../../common_nextgen/common_components/FunctionKeys/FunctionKeys";
import {
  isAddMode,
  isEditMode,
  isReadOnlyMode,
} from "../../common_nextgen/utils/UtilFunctions";

import { formFields } from "./PatientPayScheduleCriteriaFormConfig";
import { ROUTE_PATHS } from "../../common_nextgen/utils/Constants";
import useLookupNavigation from "../../common_nextgen/common_components/common-hooks/useLookupNavigation";

const screenInfo = {
  ADD: ["Add Patient Pay Schedule Criteria", "RCPPC003"],
  CHANGE: ["Patient Pay Schedule Criteria Detail", "RCPPC004"],
  VIEW: ["Patient Pay Schedule Criteria Detail", "RCPPC004"],
};

const PatientPayScheduleCriteriaForm = ({ mode }) => {
  const { PATIENT_PAY_SCHEDULE_CRITERIA } = ROUTE_PATHS;
  const location = useLocation();
  const { axios_helper_no_header } = useAxios();
  //const { state: stateVal } = location;
  const stateVal = location.state ?? [];
  let [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);

  let {
    selectedPatientPayScheduleCriterias = [],
    previousScreen = PATIENT_PAY_SCHEDULE_CRITERIA,
    currentIndex: initialIndex = 0,
    ps3PatientPaySchName,
    ps3PatientPaySchDesc,
    lookupMode: initialLookupMode = false,
    lookupScreen,
    lookupParams,
    navigateData,
    formData: baseFormData = {},
  } = currentState;
  const navigateToPage = useCustomNavigate();
  //  const [selectedOption, setSelectedOption] = useState("no");
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [currentMode, setCurrentMode] = useState(mode);
  const [initialFormData, setInitialFormData] = useState(baseFormData);
  //  const [dataForSubmission, setDataForSubmission] = useState({});
  const [constraintErrors, setConstraintErrors] = useState([]);

  //  const [lookupMode, setLookupMode] = useState(initialLookupMode);
  const toast = useToast();

  /* const { showModal } = useModal();
  const [lookupData, setLookupData] = useState({});
  const handleReceiveData = (data) => {
    //setInitialFormData({ ...initialFormData, ...data });
    if (data && Object.keys(data).length) {
      setLookupData(data);
    }
  };
  const resetLookupMode = () => {
    setLookupMode(false);
  };
  const fetchLookupData = (lookupScreen, params, formData) => {
    showModal(
      lookupScreen,
      { params },
      handleReceiveData,
      formData,
      false,
      handleNavigate,
      resetLookupMode
    );
  };

  const handleNavigate = (data, screenNumber, params, formData) => {
    console.log(data);
    if (data?.navType === "local") {
      const schedulesDataKey = data?.schedulesDataKey ?? "selectedPatients";
      console.log("scheduleDataKey", schedulesDataKey);
      navigateToPage(data.target, [
        ...previousState,
        {
          ...currentState,
          currentIndex,
          lookupMode: true,
          lookupScreen: screenNumber,
          lookupParams: params,
          navigateData: data.data,
          formData: formData,
        },
        {
          [schedulesDataKey]: [data.data],
          previousScreen: location.pathname,
          currentIndex: 0,
        },
      ]);
    }
  };

  const viewLookupDetails = (lookupScreen, params, formData) => {
    const { viewType, fieldMapping, extraParam } = params;
    const { default: screenNumber } = lookupScreen;
    const { default: viewParams } = fieldMapping;
    if (viewType === "legacy") {
      const paramData = viewParams.reduce((acc, item) => {
        const resolver = item["resolver"]
          ? LegacyResolvers[item["resolver"]]
          : null;
        acc[item["legacy"]] = resolver
          ? resolver(formData[item["source"]])
          : formData[item["source"]];
        return acc;
      }, {});
      if (extraParam) {
        delete paramData.description;
        paramData.workInitialProgramMode = "DSP";
      }
      const message = {
        message: "navigate-to-presto",
        programCode: LEGACY_SCREEN_VIEW[screenNumber],
        parameters: paramData,
      };
      console.log("message", message);
      window.top?.postMessage(message, "*");
    } else {
      const paramData = viewParams.reduce((acc, item) => {
        const resolver = item["resolver"]
          ? LegacyResolvers[item["resolver"]]
          : null;
        acc[item["target"]] = resolver
          ? resolver(formData[item["source"]])
          : formData[item["source"]];
        return acc;
      }, {});
      //console.log("param data", paramData);
      const navigationPath = ROUTE_PATHS[LOCAL_SCREEN_VIEW[screenNumber]];
      navigateToPage(navigationPath, [
        ...previousState,
        { ...currentState, currentIndex, formData: formData },
        {
          selectedPatients: [paramData],
          currentIndex: 0,
          previousScreen: location.pathname,
        },
      ]);
      // showModal(lookupScreen, { params }, null, formData, true);
    }
  };*/

  const handleBack = () => {
    if (currentIndex < selectedPatientPayScheduleCriterias.length - 1) {
      setCurrentIndex(currentIndex + 1);
      setLookupMode(false);
      setCurrentMode(mode);
    } else {
      navigateToPage(previousScreen, previousState);
    }
  };

  const getPageTitle = () => {
    const [screenTitle, screenNumber] = isAddMode(mode)
      ? screenInfo.ADD
      : screenInfo.CHANGE;
    return (
      <>
        <span className="title">{screenTitle}</span>
        <span>{"-"}</span>
        <span className="screen-number">{screenNumber}</span>
      </>
    );
  };

  const submitForm = async (dataForSubmission) => {
    let url = "";
    let verb = "";
    let screenNumber = "";
    let infoChanged = true;

    if (isAddMode(currentMode)) {
      url = "api/ppcPatientPayCriteria";
      verb = "POST";
      screenNumber = screenInfo.ADD[1];
    } else {
      url = "api/ppcPatientPayCriteria";
      verb = "PUT";
      screenNumber = screenInfo.CHANGE[1];

      if (
        JSON.stringify(dataForSubmission) === JSON.stringify(initialFormData)
      ) {
        infoChanged = false;
      }
    }

    const data = { ...dataForSubmission, screenNumber, infoChanged };

    try {
      const { responseStatus, responseData } = await axios_helper_no_header(
        verb,
        url,
        data,
        null
      );
      if (responseStatus.message === NO_CHANGE_OF_INFO) {
                                    toast.current.show({
                                      severity: "info",
                                      summary: "",
                                      detail: responseStatus.message,
                                      life: 3000,
                                    });
                                  } else {
                                    toast.current.show({
                                      severity: "success",
                                      summary: "",
                                      detail: responseStatus.message,
                                      life: 3000,
                                    }); 
      setInitialFormData(responseData);
      if (isAddMode(currentMode)) {
        setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
        const latestCurrentState = {
          ...currentState,
          selectedPatientPayScheduleCriterias: [
            { ...responseData, ps3PatientPaySchDesc: ps3PatientPaySchDesc },
          ],
          currentIndex: 0,
        };
        const lastRecord = previousState.pop();
        const { paramsData = {} } = lastRecord;

        navigateToPage(ROUTE_PATHS.PATIENT_PAY_SCHEDULE_CRITERIA_EDIT, [
          ...previousState,
          {
            ...lastRecord,
            paramsData: { ...paramsData, ppcSeqNbr: responseData.ppcSeqNbr },
          },
          latestCurrentState,
        ]);
      } else {
        setInitialFormData({
          ...responseData,
          ps3PatientPaySchDesc: ps3PatientPaySchDesc,
        });
      }
    } }catch (error) {
      const {
        responseStatus: { displayErrorFields = null, message },
      } = error.data;
      if (displayErrorFields === null) {
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      } else {
        setConstraintErrors(displayErrorFields);
      }
    }
  };

  const [keyFunc, keyName] = useMemo(() => {
    const keyFunc = {};
    const keyName = {};

    if (isAddMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
    } else if (isEditMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
      keyFunc.chmod = () => {
        setCurrentMode(PRICE_SCHEDULE_MODES.READ_ONLY);
        setLookupMode(false);
      };
      keyName.chmod = "View";
    } else if (isReadOnlyMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
      keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
      keyName.chmod = "Edit";
      keyFunc.F7 = () => {
        const message = {
          message: "navigate-to-presto",
          programCode: "RCPS6001I",
          parameters: {
            ps3PatientPaySchName: initialFormData.ps3PatientPaySchName,
          },
        };
        window.top?.postMessage(message, "*");
      };
      keyName.F7 = "Client Patient Pay Table";
    }

    return [keyFunc, keyName];
  }, [currentMode, currentIndex, initialFormData]);
  const {
    lookupData,
    fetchLookupData,
    viewLookupDetails,
    lookupMode,
    setLookupMode,
  } = useLookupNavigation({
    initialLookupMode,
    lookupParams,
    initialIndex,
    previousState,
    currentState,
    lookupScreen,
    navigateData,
    initialFormData,
  });

  useEffect(() => {
    const fetchInitialData = async () => {
      const params = isAddMode(currentMode)
        ? { ps3PatientPaySchName: ps3PatientPaySchName }
        : {
            ppcSeqNbr:
              selectedPatientPayScheduleCriterias[currentIndex].ppcSeqNbr,
          };
      const url = isAddMode(currentMode)
        ? `api/ppcPatientPayCriteria/initialFormData/${encodeURIComponent(
            screenInfo.ADD[1]
          )}`
        : `api/ppcPatientPayCriteria/${encodeURIComponent(
            ps3PatientPaySchName
          )}`;
      const { responseData } = await axios_helper_no_header(
        "GET",
        url,
        {},
        params
      );
      setInitialFormData({
        ...responseData,
        ps3PatientPaySchName: ps3PatientPaySchName,
        ps3PatientPaySchDesc: ps3PatientPaySchDesc,
      });
    };

    if (initialLookupMode && Object.keys(baseFormData).length) {
      setInitialFormData(baseFormData);
    } else {
      fetchInitialData();
    }
  }, [mode, currentIndex]);

  /*  useEffect(() => {
    if (lookupMode && initialFormData && Object.keys(initialFormData).length) {
      //console.log("lookup auto init", initialFormData, navigateData);
      //const lookupParamsData =
      console.log("navigate data", lookupParams, navigateData);
      //navigateData;
      const params = lookupParams.fieldMapping.default;
      const paramData = params?.reduce((acc, key) => {
        if (navigateData.hasOwnProperty(key["target"])) {
          acc[key["source"]] = navigateData[key["target"]];
        }
        return acc;
      }, {});
      showModal(
        lookupScreen,
        { params: lookupParams },
        handleReceiveData,
        { ...initialFormData, ...paramData },
        null,
        handleNavigate,
        resetLookupMode
      );
    }
  }, [initialFormData, lookupMode, lookupParams, lookupScreen]);

  /*  useEffect(() => {
    setCurrentIndex(initialIndex);
  }, [initialIndex]);
  useEffect(() => {
    setLookupMode(initialLookupMode);
  }, [initialLookupMode]);
*/

  return (
    <div className="grid container">
      <div className="col col-12">
        <FunctionKeys keyFunc={keyFunc} keyName={keyName} />
      </div>
      <div className="col col-12">
        <h1>{getPageTitle()}</h1>
      </div>
      <div className="col col-12">
        <Form
          formData={initialFormData}
          formFields={formFields}
          mode={currentMode}
          submitFormData={submitForm}
          constraintErrors={constraintErrors}
          lookupData={lookupData}
          fetchLookupData={fetchLookupData}
          viewLookupDetails={viewLookupDetails}
        />
      </div>
    </div>
  );
};

export default PatientPayScheduleCriteriaForm;
